export default function getDocumentTypeKey(documentType) {
  switch (documentType) {
    case "TX":
      return 1
    case "AB":
      return 2
    case "DR":
      return 3
    case "CR":
      return 4
    case "RE":
      return 5
    case "RT":
      return 6
    case "CL":
      return 7
    case "P":
      return "P"
    case "S":
      return "S"
    default:
      return ""
  }
}
